import { render, staticRenderFns } from "./orders.vue?vue&type=template&id=97074038&scoped=true"
import script from "./orders.vue?vue&type=script&lang=js"
export * from "./orders.vue?vue&type=script&lang=js"
import style0 from "./orders.vue?vue&type=style&index=0&id=97074038&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97074038",
  null
  
)

export default component.exports